import { Pane } from 'tweakpane';

export class OfferEditorStateMenu<S> {
  public readonly element = document.createElement('div');

  constructor(state: S, actions: Record<string, Record<string, (state: S) => void>>) {
    Object.assign(this.element.style, {
      position: 'fixed',
      top: '0',
      right: '800px',
    });
    document.body.appendChild(this.element);

    const pane = new Pane();
    this.element.appendChild(pane.element);
    const folder = pane.addFolder({ title: 'State actions' });

    Object.entries(actions).forEach(([title, categoryActions]) => {
      const actionsFolder = folder.addFolder({ title, expanded: false });

      Object.entries(categoryActions).forEach(([key, action]) => {
        actionsFolder.addButton({ title: key }).on('click', () => {
          action(state);
        });
      });
    });
  }
}
